export const apiUrls = {
    login: "login",
    logout: "logout",
    categoryListing: "category-listing",
    productListing: "product-listing",
    colorsListing: "colors-listing",
    sizesListing: "sizes-listing",
    bannerListing: "banner-listing",
    signupOtp: "signupOtp",
    verifysignupOtp: "verifysignupOtp",
    setPassword: "setPassword",
    productView: "product-view",
    productSave: "product-save",
    productSaveListing: "product-save/listing",
    cartList: 'cart/list',
    cartAdd: 'cart/add',
    cartUpdate: 'cart/update',
    cartDelete: 'cart/delete',
    promotionListing: 'promotion-listing',
    reviewAdd: 'review/add',
    testimonialListing: 'testimonial-listing',
    productSaveListing: 'product-save/listing',
    editProfile: 'edit-profile',
    adressUpdate: 'adress/update',
    changePassword: 'change-password',
    deleteAccount: 'delete-account',
    forgotPasswordSendMail: 'forgot-password-sentmail',
    forgotPasswordVerifyOTP: 'forgot-password-verifyotp',
    resetPassword: 'reset-password',
    faqListing: 'faq-listing',
    productSearch: 'product-search',
    sliderListing: 'slider-listing',
    couponCheck: 'coupon/check',
    suggestedSizeAdd: 'suggested_size/add',
    checkoutItems: 'checkout/items',
    checkoutPayment: 'checkout/payment',
    checkoutVerify: 'checkout/verify',
    checkoutPaypalPayment: 'checkout/paypal_payment',
    checkoutPaypalVerify: 'checkout/paypal_verify',
    ordersUserView: 'orders/user_view',
    ordersSingleView: 'orders/single_view',
    contactForm: 'contact-request',
    aiLogosAdd: 'ai_logos/add',
    aiLogosListing: 'ai_logos/listing',
    aiLogosDeleteLogo: 'ai_logos/delete_logo',
    newsletterSubscribe: 'newsletter/subscribe',
    checkoutEstimate: 'checkout/estimate',
    generateImage: 'ai_logos/generate-image',
    generateImageEdit: 'ai_logos/generate-image-edit',
    coupons: 'coupons',
    cartUpdateLogos: 'cart/update-logos',
    printingPrices: 'printing-prices'
};
